const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5058';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    PATIENTS: '/patients',
    USERS: '/users',
    PATIENT_APPOINTMENTS: '/patients/{patientId}/appointments',
    PATIENT_PAYMENTS: '/patients/{patientId}/payments',
    PATIENT_MEDICAL_STORIES: '/patients/{patientId}/medical-stories',
    APPOINTMENTS: '/appointments',
    APPOINTMENT_SEARCH: '/appointments/search',
    EVENTS: '/events',
    CALENDAR_IMPORT: '/calendar/import',
    CALENDAR_PUSH: '/calendar/push',
    CALENDAR_STATUS: '/calendar/status',
    CALENDAR_DISCONNECT: '/calendar/disconnect',
    CALENDAR_AUTHORIZE: '/calendar/authorize',
    CALENDAR_SELECT: '/calendar/select',
    CALENDAR_LIST: '/calendar/list',
    PAYMENTS: '/payments',
    CALENDAR_PAYMENTS: '/payments/calendar',
    STANDALONE_TREATMENT_PAYMENT: '/payments/standalone-treatment',
    MEDICAL_STORIES: '/medical-stories',
    PATIENT_PHOTOS: '/patients/{patientId}/photos',
    PATIENT_PHOTO_DELETE: '/patients/photos/{id}',
    DOCTORS: '/doctors',
    // New endpoints for extended patient domain
    ALLERGIES: '/allergies', // global allergy catalog
    ALLERGY_MEDICATIONS: '/allergies/{allergyId}/medications',
    ALLERGY_MEDICATION_DELETE: '/allergies/medications/{medId}',
    PATIENT_ALLERGIES: '/patients/{patientId}/allergies', // list + add (POST) patient allergy
    PATIENT_ALLERGY_DELETE: '/patients/{patientId}/allergies/{allergyId}', // DELETE unlink
    FAMILY_LINKS: '/patients/{patientId}/family-links', // list + POST create link
    FAMILY_LINK_DELETE: '/patients/{patientId}/family-links/{linkId}', // DELETE link
    SET_RESPONSIBLE: '/patients/{patientId}/responsible/{responsibleId}', // PUT assign responsible party
    PATIENT_TREATMENTS_IN_PROGRESS: '/patients/{patientId}/treatments/in-progress',
    TREATMENTS: '/treatments',
    TREATMENT_TEMPLATES: '/treatment-templates',
    TREATMENT_SPECIALTIES: '/treatment-specialties',
    TREATMENT_TEMPLATE_STATS: '/treatment-templates/stats',
    LABORATORIES: '/laboratories',
    REPORTS_DOCTORS: '/reports/doctors',
    WHATSAPP_STATUS: '/whatsapp/status',
    WHATSAPP_SETTINGS: '/whatsapp/settings',
    WHATSAPP_CONVERSATIONS: '/whatsapp/conversations',
    WHATSAPP_TEMPLATES: '/whatsapp/templates',
    WHATSAPP_TEMPLATES_SYNC: '/whatsapp/templates/sync'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string, params?: Record<string, string | number>) => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  // Replace path parameters like {patientId}
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      url = url.replace(`{${key}}`, String(value));
    });
  }
  
  return url;
};

// Helper function to create headers with auth token
export const getAuthHeaders = (token: string) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`
});

// Helper function for common headers without auth
export const getHeaders = () => ({
  'Content-Type': 'application/json'
});
